import { AxiosInstance } from 'axios';
import { IUser } from 'src/views/Admin/Users/types';
import { insertId } from '../../insertId';
import * as mapUser from './utils/mapUser';

const toResponse = (data: any): IUser => {
  if (!data.success) {
    throw new Error(
      `Response failed with code ${data.statusCode}: ${data.errorMessage}`
    );
  }
  return mapUser.fromServer(data.result);
};

export default (api: AxiosInstance, url: string) => async (user: IUser) => {
  const urlWithId = insertId(url, user.id);
  const response = await api.put(urlWithId, mapUser.toServer(user));
  return toResponse(response.data);
};



// WEBPACK FOOTER //
// ./src/services/api/admin/users/update.ts